import axiosInstance from "../../core/axiosConfig.ts";

export default class AgencyService {
    async getAgencies() {
        const response = await axiosInstance.get(
            '/admin/agency/list'
        );
        return response.data;
    }

    
}